import { LegalLayout } from "../components/LegalLayout";

const SECTIONS = [
  { h: "Overview", p: [
    "This Privacy Policy explains what information we collect through yeswecanlending.com, why we collect it, and how it's used — in plain language. It applies to the webinar registration pages and any other pages on this site operated by Yes We Can Lending Corporation LLC (\u201cwe,\u201d \u201cus,\u201d \u201cour\u201d).",
  ]},
  { h: "Information We Collect", p: [
    "We collect the information you voluntarily submit through our webinar registration or contact forms: your name, email address, phone number, state, and any details you choose to share about your homebuying journey.",
    "We also collect standard technical data — IP address, browser type, device type, pages visited, and referring URL — via cookies and similar tracking technologies.",
  ]},
  { h: "How We Use Your Information", p: [
    "We use your information to register you for the webinar/event, send you the materials you requested, and follow up about mortgage products and services you've expressed interest in — including automated email and SMS messages you can opt out of at any time.",
    "We also use it to improve our site and to comply with legal and regulatory recordkeeping obligations applicable to licensed mortgage professionals.",
  ]},
  { h: "Cookies & Tracking Technologies", p: [
    "We use the Meta (Facebook) Pixel to measure ad performance and build audiences for future advertising. We use Google Analytics to understand site usage.",
    "You can disable cookies in your browser settings; this may affect site functionality.",
  ]},
  { h: "How We Share Your Information", p: [
    "We do not sell your personal information. We may share it with: (a) service providers who help us operate this site and fulfill your request (e.g. our CRM/scheduling platform, GoHighLevel); (b) wholesale lenders and settlement service providers as needed to process a mortgage inquiry you initiate; and (c) as required by law, regulation, or a valid legal process.",
  ]},
  { h: "TCPA Consent", p: [
    "By submitting your phone number, you consent to receive calls and text messages from Yes We Can Lending Corporation LLC and Velisa Johnson, including by automated means, about mortgage products and services. Consent is not a condition of any purchase. Message and data rates may apply. Reply STOP to opt out of texts at any time.",
  ]},
  { h: "Your Rights & Choices", p: [
    "You may request access to, correction of, or deletion of your personal information by contacting velisa.yeswecan@gmail.com.",
    "California residents have additional rights under the California Consumer Privacy Act (CCPA), including the right to know what personal information is collected, the right to request deletion, and the right to opt out of the sale of personal information (we do not sell personal information). To exercise these rights, contact us at velisa.yeswecan@gmail.com.",
  ]},
  { h: "Data Security", p: [
    "We use reasonable administrative, technical, and physical safeguards to protect your information, but no method of transmission or storage is 100% secure.",
  ]},
  { h: "Children's Privacy", p: [
    "This site is not directed to children under 13, and we do not knowingly collect information from children.",
  ]},
  { h: "Changes to This Policy", p: [
    "We may update this policy from time to time; the effective date above reflects the most recent revision.",
  ]},
  { h: "Contact Us", p: [
    "Yes We Can Lending Corporation LLC, [[NEEDS CONFIRMATION — business address]], velisa.yeswecan@gmail.com, (702) 608-0721. NMLS #2656519 (Velisa Johnson) / Company NMLS #2656519. Licensed in Nevada and Texas. Equal Housing Lender.",
  ]},
];

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Privacy Policy"
      subtitle={'Yes We Can Lending Corporation LLC ("we," "us," "our") — Effective August 1, 2026'}
      sections={SECTIONS}
      testId="privacy-policy-page"
    />
  );
}
